import { ValueName } from 'src/@types/shared/valueName';
import { FileExtensions } from 'src/@types/fileView/enums/fileExtensions';

const TABS: ValueName<number>[] = [
  {
    value: 1,
    localeName: 'documents.editing',
  },
  {
    value: 2,
    localeName: 'documents.attachments',
  },
];

const AVAILABLE_EXTENSIONS: string[] = [
  FileExtensions.Pdf,
  FileExtensions.Doc,
  FileExtensions.Docx,
  FileExtensions.Xls,
  FileExtensions.Xlsx,
  FileExtensions.Png,
  FileExtensions.Jpeg,
  FileExtensions.Jpg,
];

const MAX_FILES = 5;

export default {
  TABS,
  AVAILABLE_EXTENSIONS,
  MAX_FILES,
};
